import { render, staticRenderFns } from "./ReferralSummary.vue?vue&type=template&id=4cdc95be&scoped=true&"
import script from "./ReferralSummary.vue?vue&type=script&lang=js&"
export * from "./ReferralSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdc95be",
  null
  
)

export default component.exports